import { useMutation } from '@tanstack/react-query'
import { IManualInvoicingRequestPayload, submitManualInvoicingRequest } from '../subscriptions'

interface UseManualInvoicingRequestProps {
  slug: string
}

export const useManualInvoicingRequest = ({ slug }: UseManualInvoicingRequestProps) => {
  const mutation = useMutation({
    mutationFn: (data: IManualInvoicingRequestPayload) =>
      submitManualInvoicingRequest({ slug }, data)
  })

  return {
    submitManualInvoicingRequest: mutation.mutateAsync,
    isSubmittingManualInvoicingRequest: mutation.isPending
  }
}
